<template lang="pug">
section.form_container.py-5
  .container
    .row.align-items-center
      .col-12.col-lg-9.border.home-contact-block
        h3.title.text-center 還不是很清楚嗎? 請客服專員與您聯絡！
        .border-hr
        form.new_contact(@submit="submitForm")
          .row.mt-3
            .col-lg-12
              span 學生姓名
              input.form-control(required="true", v-model="name", type="text")
          .row.mt-1
            .col-lg-6
              span 家長聯絡電話
              input.form-control(required="true", v-model="phone", type="tel")
            .col-lg-6
              span 家長line ID
              input.form-control(
                required="true",
                v-model="line_id",
                type="text"
              )
            .col-lg-12
              span 電子信箱
              input.form-control(
                required="true",
                v-model="email",
                type="email"
              )
          .row.mt-1
            .col-lg-6
              span 就讀學校
              input.form-control(
                required="true",
                v-model="school",
                type="text"
              )
            .col-lg-6
              span 年級
              input.form-control(required="true", v-model="grade", type="text")
          .row.mt-1
            .col-lg-12
              span 如何得知訊息
              select#contact_hear_from.form-control(
                placeholder="請選擇",
                v-model="contact_from"
              )
                option(value="NONE") 無
                option(value="FACEBOOK") Facebook
                option(value="INSTAGRAM") Instagram
                option(value="LINE") Line
                option(value="GOOGLE") Google搜尋
                option(value="FRIEND") 親友介紹
                option(value="OTHER") 其他
          .submit-btn.mt-3
            input.btn.normal-btn(type="submit", value="送出資料")
  dialog-success(
    v-if="successDialogShow",
    :title="successDialogTitle",
    :content="successDialogContent"
  )
  dialog-loading(v-if="loadingDialogShow", :content="loadingContent")
</template>

<script>
import { contactUs } from "@/api/contact";
import { errorMessage } from "@/utils/message";
import DialogSuccess from "@/components/login/DialogSuccess";
import DialogLoading from "@/components/dialog/DialogLoading";

export default {
  name: "Form",
  components: {
    "dialog-success": DialogSuccess,
    "dialog-loading": DialogLoading,
  },
  data() {
    return {
      name: "",
      school: "",
      grade: "",
      phone: "",
      line_id: "",
      email: "",
      contact_from: "NONE",
      successDialogShow: false,
      successDialogTitle: "",
      successDialogContent: "",
      loadingDialogShow: false,
      loadingContent: "傳送中....",
    };
  },
  methods: {
    submitForm(e) {
      this.loadingDialogShow = true;
      e.preventDefault();
      let inputData = {
        name: this.name,
        school: this.school,
        grade: this.grade,
        phone: this.phone,
        line_id: this.line_id,
        email: this.email,
        contact_from: this.contact_from,
      };
      contactUs(inputData)
        .then(() => {
          this.loadingDialogShow = false;
          this.resetInputData();
          this.successDialogShow = true;
          this.successDialogTitle = "報名成功";
          this.successDialogContent = "感謝您的報名，我們會盡快與您聯絡";
          setTimeout(() => {
            this.successDialogShow = false;
            this.successDialogTitle = "";
            this.successDialogContent = "";
          }, 1500);
        })
        .catch(() => {
          this.loadingDialogShow = false;
          errorMessage(this, "報名失敗", "請確認資料是否正確或稍後再試");
        });
    },
    resetInputData() {
      this.name = "";
      this.school = "";
      this.grade = "";
      this.phone = "";
      this.line_id = "";
      this.email = "";
      this.contact_from = "NONE";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/home/form.scss";
</style>
